import type { ReactNode, ReactElement } from 'react'

export function ReportSection({ title, description, action, children }: {
  title: string; description?: string; action?: ReactNode; children: ReactNode
}): ReactElement {
  return <section className="overflow-hidden rounded-2xl border bg-card" aria-label={title}>
    <header className="flex flex-wrap items-start justify-between gap-4 border-b px-5 py-5 sm:px-6">
      <div><h2 className="text-lg font-semibold tracking-tight">{title}</h2>
        {description && <p className="mt-1 max-w-2xl text-sm text-muted-foreground">{description}</p>}
      </div>{action}
    </header>
    <div className="space-y-5 p-5 sm:p-6">{children}</div>
  </section>
}

export function ReportMetric({ label, value, hint, tone = 'neutral' }: {
  label: string; value: ReactNode; hint?: string; tone?: 'neutral' | 'warning' | 'danger'
}): ReactElement {
  return <div className="min-w-0 rounded-xl border bg-background px-4 py-4">
    <p className="text-sm text-muted-foreground">{label}</p>
    <p className={`mt-2 text-3xl font-semibold tabular-nums tracking-tight ${tone === 'danger' ? 'text-red-700' : tone === 'warning' ? 'text-amber-800' : ''}`}>{value}</p>
    {hint && <p className="mt-2 text-xs text-muted-foreground">{hint}</p>}
  </div>
}

export function ReportEmpty({ title, description }: { title: string; description: string }): ReactElement {
  return <div className="rounded-xl border border-dashed bg-muted/20 px-5 py-8 text-center">
    <h3 className="font-medium">{title}</h3><p className="mx-auto mt-2 max-w-xl text-sm text-muted-foreground">{description}</p>
  </div>
}
